<template>
	<div v-if="is_logged_in"  class="home">
		<div class="col-md-offset-1 col-md-10">

			<!-- DESKTOP -->
			<div  v-if="$mq !== 'mobile'">


            </div>

			<!-- MOBILE -->
			<div  v-if="1==1  ||  $mq === 'mobile'">
                <div class="panel panel-default drop-shadow">

                    <div class="panel-heading panel-grey text-left">
                        UPLOAD
                    </div>
                    
                    <div class="" style="clear:both; padding:10px;">

                        Enter the subject of your upload below.
                        <br>


                        <div class="form-group">
                            <label class="control-label text-left" style='padding-top:7px; width:100%;' >
                                <b>Subject:</b>
                            </label>
                            <div class="text-left">
                                <input  name="subject"  type="text"  class="form-control" style='width:100%; v-align:middle;' autofocus
                                        v-validate="'required|max:250'"
                                        v-model="subject"
                                        :disabled="is_before_upload == false"
                                >
                                <span class="text-danger">{{ errors.first('subject') }}</span>
                            </div>
                        </div>

                        <div v-if="is_before_upload == true"
                             class="" 
                             style="width:100%;
                                    display:flex; justify-content:space-between; align-items:center;
                                    clear:both;">
                            <div>
                                <button  
                                    @click="chooseFile()"  
                                    :disabled="is_before_upload == false"
                                    name="button"  type="submit"  
                                    class="btn btn-success"  
                                    style="width:160px; border:2px solid black; margin:6px;"
                                >
                                    <font size=+0><b>Select Files</b></font>
                                </button>
                            </div>
                            <div class="text-left">
                                Select up to 25 files, up to 50MB each
                            </div>
                        </div>


                        <div class="d-flex" style="display:none;">
                            <label for="file-upload"
                                    class=""
                            >
                                <span @click="chooseFile">Choose a file</span>
                                <input id="images"
                                    name="images"
                                    type="file"
                                    ref="file"
                                    multiple
                                    @change="chooseFileSelected"
                                />
                            </label>
                            <p class="pl-1">or drag and drop</p>
                        </div>

                        <div class="text-left" style='padding-top:7px; width:100%;' >
                                <span style="padding-bottom:2px;"><b>Files:</b></span>

                                <!-- Files list -->
                                <div v-if="is_during_upload == true  ||  is_after_upload == true" 
                                     id="file-list"
                                     class=""
                                     style="width:100%; max-height:420px; overflow-y:scroll;
                                            padding:4px; border:1px solid #ccc; border-radius:4px;
                                            box-shadow:inset 0 1px 1px rgba(0, 0, 0, .075); ">

                                    <div v-for="file in upload_files_list" :key="file.name"  
                                         class=""  
                                         style="display:flex; flex-direction:row; justify-content:flex-start; align-items:center;
                                                border-bottom: #cccccc 1px solid;
                                                padding-top:4px; vertical-align:top;">
                                        <div style="padding-right:4px;">
                                            <small v-if="file.uploading == 'uploading'"
                                                   class="text-right" 
                                                   style="display: inline-block; min-width:20px;">
                                                <i class='fa fa-arrow-circle-right' style='font-size:14px; color:green;'></i>
                                            </small>
                                            <small v-else-if="file.uploading == 'uploaded'"
                                                   class="text-right" 
                                                   style="display: inline-block; min-width:20px;">
                                                <i class='fa fa-check' style='font-size:14px; color:green;'></i>
                                            </small>
                                            <small v-else-if="file.uploading == 'error'"
                                                   class="text-right" 
                                                   style="display: inline-block; min-width:20px;">
                                                <i class='fa fa-times' style='font-size:14px; color:darkred;'></i>
                                            </small>
                                            <small v-else
                                                   class="text-right" 
                                                   style="display: inline-block; min-width:20px;">
                                                -
                                            </small>
                                        </div>

                                        <div>
                                            <small v-if="file.uploading == 'uploaded' ||  file.uploading == 'error'"
                                                   style="color:#cccccc; word-break:break-all;">{{ file.name }}</small>
                                            <small v-else
                                                   style="word-break:break-all;">{{ file.name }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="got_files == true" 
                                     class=""
                                     style="width:100%; max-height:420px; overflow-y:scroll;
                                            padding:4px; border:1px solid #ccc; border-radius:4px;
                                            box-shadow:inset 0 1px 1px rgba(0, 0, 0, .075); ">

                                    <div v-for="file in upload_files_list" :key="file.name"  
                                         class=""
                                         style="display:flex; flex-direction:row; justify-content:flex-start; align-items:center;
                                                border-bottom: #cccccc 1px solid;
                                                padding-top:4px; vertical-align:top;">

                                        <div style="padding-right:4px;">
                                            <svg @click="removeFile(file.name)" 
                                                height="14px" width="14px" 
                                                viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 6H20L18.4199 20.2209C18.3074 21.2337 17.4512 22 16.4321 22H7.56786C6.54876 22 5.69264 21.2337 5.5801 20.2209L4 6Z" stroke="#ff3333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7.34491 3.14716C7.67506 2.44685 8.37973 2 9.15396 2H14.846C15.6203 2 16.3249 2.44685 16.6551 3.14716L18 6H6L7.34491 3.14716Z" stroke="#ff3333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M2 6H22" stroke="#ff3333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M10 11V16" stroke="#ff3333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 11V16" stroke="#ff3333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                                            </svg>                                            
                                        </div>
                                        <div>
                                            <small style="word-break:break-all;">{{ file.name }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div v-else
                                     class=""
                                     style="width:100%; max-height:420px; overflow-y:scroll;
                                            padding:4px; border:1px solid #ccc; border-radius:4px;
                                            box-shadow:inset 0 1px 1px rgba(0, 0, 0, .075); ">

                                    <small>Click "Select Files" to add files to upload list.</small>
                                </div>
                                <!-- End files list -->
                        </div>

                    </div>

                    <div class="" style="padding-top:5px; clear:both;">
                        <center>
                            <button  v-if="is_before_upload == true" 
                                    @click="uploadFiles()"  
                                    :disabled="!is_ok_to_send"
                                    name="button"  type="submit"  
                                    class="btn btn-primary btn-block"  
                                    style="width:200px; border:2px solid black; margin:10px;"
                            >
                                <font size=+1><b>Upload Files</b></font>
                            </button>

                            <div v-else-if="is_after_upload == true"
                                    class="btn btn-block"  
                                    style="width:200px; margin:10px; color:#000000 !important;"
                            >
                                <font size=+1>
                                    <i class='fa fa-check' style='padding-right:5px; font-size:14px; color:green;'></i>
                                    <b>Upload Complete</b>
                                </font>
                            </div>

                            <button v-else
                                    :disabled=true
                                    class="btn btn-primary btn-block"  
                                    style="width:200px; border:2px solid black; margin:10px;"
                            >
                                <font size=+1><b>Uploading ... {{ current_file }} of {{ upload_files_list.length }}</b></font>
                            </button>
                        </center>
                    </div>

                    <div v-if="has_uploaded == true"
                         class="" 
                         style="width:100%;
                                display:flex; justify-content:space-between;
                                padding-top:10px; clear:both;">
                        <div>
                            <button  @click="$router.push({'name': 'files'});"  
                                     name="button"  type="submit"  
                                     class="btn btn-primary btn-block"  
                                     style="width:140px; border:2px solid black; margin:5px;">
                                <font size=+0><b>My Files</b></font>
                            </button>
                        </div>
                        <div>
                            <button  @click="uploadDone()"  
                                     name="button"  type="submit"  
                                     class="btn btn-info btn-block"  
                                     style="width:140px; border:2px solid black; margin:5px;">
                                <font size=+0><b>Done</b></font>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
	</div>
</template>


<script>
import EventBus from '@/event_bus';					// Event Bus

export default {
	name: 'home',

	props: {
	},
	
	components: {
        EventBus
	},
	
	data() {
		return {
			env:                        process.env.VUE_APP_ENV,
			api_token:                  '',

            dropZoneActive:             false,

            current_file:               0,
            upload_files_list:          [],
            upload_files_list_count:    0,
            upload_id:                  null,
            subject:                    null,

            is_uploading:               false,
            has_uploaded:               false,
            max_size_allowed:           (50 * 1024 * 1024),
            //allowed_types:     [
            //    'image/jpg',
            //    'image/jpeg',
            //    'image/png',
            //    'image/gif',
            //],
		};
	},

	computed: {
		is_logged_in() {
			var status     = false;
			this.api_token = localStorage.getItem('api_token');
			
			if (this.api_token  &&  this.api_token.length == 64) {
				status = true;
			}
				
			return status;
		},

		user() {
			return this.$store.getters.USER;
		},

        got_files() {
            return (this.upload_files_list  &&  this.upload_files_list.length > 0)
        },

        is_before_upload() {
            if (this.is_uploading == false  &&  this.has_uploaded == false) {
                return true;
            }
            else {
                return false;
            }
        },
        is_during_upload() {
            return (this.is_uploading == true);
        },
        is_after_upload() {
            return (this.has_uploaded == true);
        },

        is_ok_to_send() {
            return (this.is_before_upload == true  &&  this.subject  &&  this.subject != ''  &&  this.got_files);
        },
	},
	
	created() {
        this.upload_id = this.$store.getters.COLLECTION_UPLOAD_ID;

        if (this.upload_id == null) {
            this.$router.push({ name: 'home' });
        }
    },

	mounted() {
    },
    
	destroyed() {
        this.vueInsomnia().off();        // allow browser-sleep
	},

	methods: {
        chooseFile() {
            const fileInput = document.getElementById('images');
            fileInput.click();
        },
    
        chooseFileSelected(e) {
            this.handleFileDrop({ dataTransfer: document.getElementById('images') });
        },
    
        removeFile(file_name) {
            this.upload_files_list = this.upload_files_list.filter(e => {
                return e.name !== file_name;
            });
        },

        handleFileDrop(event) {
            const dropped_filelist = event.dataTransfer.files

            // Go through dropped files and handle pre-upload-checks
            for (let i = 0; i < dropped_filelist.length; i++) {
                let dropped_file = dropped_filelist.item(i)

                // Remove if already on the list
                this.upload_files_list = this.upload_files_list.filter(e => {
                    return e.name !== dropped_file.name;
                })

                // Add to list
                if (i >= 25) {
                    console.log('File (' + i + ')"' + dropped_file.name + '" not added - over 25 files already');
                }
                else if (dropped_file.size < this.max_size_allowed ) {
                    //if ( this.allowed_types.includes(dropped_file.type.toLowerCase()) ) {
                        dropped_file['uploading'] = false;
                        this.upload_files_list.push(dropped_file);
                    //}
                    //else {
                    //    console.log('File "' + dropped_file.name + '" not added - wrong type: ' + dropped_file.type);
                    //}
                }
                else {
                    console.log('File "' + dropped_file.name + '" not added - too big: ' + dropped_file.size);
                }
            }
        },
        
        wait(ms) {
            const start = Date.now();
            let     now = start;
            while (now - start < ms) {
                now = Date.now();
            }
        },

        async uploadFiles() {
            this.is_uploading = true;
            this.vueInsomnia().on();        // stop browser going to sleep

            // Upload each file 1 by 1
            for (let i = 0; i < this.upload_files_list.length; i++) {
                this.current_file = (i + 1);
                this.upload_files_list[i]['uploading'] = 'uploading';
                //console.log('uploading: ', this.upload_files_list[i]);

                var rc = await this.sendFile(this.upload_files_list[i]);
                if (rc == true) {
                    this.upload_files_list[i]['uploading'] = 'uploaded';

                    var file_list_div = document.getElementById("file-list");
                    file_list_div.scrollTop = file_list_div.scrollHeight;
                }
                else {
                    this.upload_files_list[i]['uploading'] = 'error';
                }
            }

            // Tell API all done
            rc = await this.completeUpload();

            this.has_uploaded = true;
            this.is_uploading = false;
            this.vueInsomnia().off();        // allow browser-sleep
            
            if (rc == true) {
                //
            }
        },

        async sendFile(upload_file) {
            //
            const headers = {
                "Content-Type": "multipart/form-data",
            }

            var formData = new FormData()

            formData.append("api_token", this.api_token);
            formData.append("upload_id", this.upload_id);
            formData.append("subject",   this.subject);
            formData.append("file",      upload_file);
        
            //console.log('uploading: "' + upload_file.name +'"');
            try {
                var res = await this.axios.post('api/upload/data', formData, {headers: headers});
                if (res.status == '200') {
                    return true;
                }
            }
            catch(error) {

                var error_msg = '';
                if (error.response) {
                    if (error.response.data.message) {
                        error_msg = error_msg + error.response.data.message + "<br>";	
                    }
                    
                    if (error.response.data.error) {
                        Object.keys(error.response.data.error).forEach(key => {
                            error_msg = error_msg + error.response.data.error[key] + "<br>";

                            // load api errors into client errors
                            this.errors.add({
                                field: key,
                                msg:   error.response.data.error[key],
                            });
                        });
                    }

                    this.$notify({
                        group: "fs_danger",
                        title: "Error",
                        text: error_msg,
                        type: "error"
                    });
                }
                else if (error.message == "Network Error") {
                    localStorage.removeItem('api_token');
                    this.$store.commit("RESET");
                    this.api_token = null;

                    this.$notify({
                        group: "fs_warning",
                        title: "Session has expired",
                        text:  "Please log in again.",
                        type:  "error"
                    });

                    EventBus.$emit('refresh_header_api_token', this.api_token);
                    this.$router.push({'name': 'home'});
                }
                else {
                    console.log('sendFile()  unexpected error: ', JSON.stringify(error));

                    this.$notify({
                        group: "fs_danger",
                        title: "Error",
                        text: "Unexpected error on upload.",
                        type: "error"
                    });
                }

                return false;
            }
            
            return false;       // there was an error
        },

        async completeUpload() {
            //
            const headers = {
                "Content-Type": "multipart/form-data",
            }

            var formData = new FormData()

            formData.append("api_token", this.api_token);
            formData.append("upload_id", this.upload_id);

            try {
                var res = await this.axios.post('api/upload/complete', formData, {headers: headers});
                if (res.status == '200') {
                    return true;
                }
            }
            catch(error) {
                console.log('completeUpload()  unexpected error: ', JSON.stringify(error));
            }
            
            return false;       // there was an error
        },

		async uploadDone() {
            //
            this.$router.push({ name: 'home' });
            /*
            const headers = { "Content-Type": "multipart/form-data" };
            var formData  = new FormData();

            formData.append("api_token", this.api_token);

            //console.log('uploading');
            try {
                var res = await this.axios.post('api/upload/start', formData, {headers: headers});
                //console.log('upload_start res =', res);

                this.$store.commit("COLLECTION_UPLOAD_ID", res.data.id);
                this.$router.push({ path: 'upload_start' });

            }
            catch(e) {
                console.log('upload_start error=',e);
            }
            */
        },
    },
}

</script>
